import Swal from "sweetalert2";

const GlobalSwal = Swal.mixin({
  buttonsStyling: false,
  customClass: {
    confirmButton: "btn btn-primary",
    cancelButton: "btn btn-secondary"
  },
  didOpen: () => {
    Swal.getPopup()?.focus()
    Swal.getConfirmButton()?.blur()
    Swal.getCancelButton()?.blur()
  },
});

export { GlobalSwal }
